module.exports = __webpack_public_path__ + "static/media/logo.3acb4bd4.png";